var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resolvedBlock,_vm._b({tag:"component",attrs:{"content":_vm.block,"aspect-ratio":_vm.block.aspectRatio}},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }